import { render, staticRenderFns } from "./IntergisCfs.vue?vue&type=template&id=3976ca7b"
import script from "./IntergisCfs.vue?vue&type=script&lang=js"
export * from "./IntergisCfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3976ca7b')) {
      api.createRecord('3976ca7b', component.options)
    } else {
      api.reload('3976ca7b', component.options)
    }
    module.hot.accept("./IntergisCfs.vue?vue&type=template&id=3976ca7b", function () {
      api.rerender('3976ca7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/IntergisCfs.vue"
export default component.exports